import { map, identity, isArray, isPlainObject, reduce, camelCase, snakeCase, omitBy, isUndefined } from 'lodash';
export function transformObjectKeys(obj, trasformer) {
  if (trasformer === void 0) {
    trasformer = identity;
  }
  if (isArray(obj)) {
    return map(obj, val => transformObjectKeys(val, trasformer));
  }
  if (isPlainObject(obj)) {
    return reduce(obj, (acc, value, key) => {
      acc[trasformer(key)] = transformObjectKeys(value, trasformer);
      return acc;
    }, {});
  }
  return obj;
}
export function keysToCamelCase(obj) {
  return transformObjectKeys(obj, camelCase);
}
export function keysToSnakeCase(obj) {
  return transformObjectKeys(obj, snakeCase);
}
export function removeUndefinedValues(obj) {
  return omitBy(obj, isUndefined);
}
//# sourceMappingURL=object.js.map